import { FDProgress } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';

export const Progress = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    label,
    value,
    icon,
    ...rest
  } = props;
  const dataAttrs = useDataAttrs(rest);

  if (value === '' || value === undefined || value === null) {
    return null;
  }

  return (
    <FDProgress
      {...dataAttrs}
      alignSelf={alignSelf}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      label={label}
      value={value.replace('%', '') / 100}
      icon={icon}
    />
  );
};

Progress.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  label: inputDefaultProps.label,
  icon: undefined,
};

Progress.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: inputPropTypes.label,
  value: inputPropTypes.value.isRequired,
  icon: PropTypes.string,
};
